export var PrimaryCurrency = `GH₵ `;
